module.exports = __webpack_public_path__ + "img/1268.2c300628.gif";